export default __webpack_public_path__ + "static/media/booklightcolor.072e4fb0.png";